// extracted by mini-css-extract-plugin
export default {"recentsWrapper":"RecentsModule_recentsWrapper__8OoCL","recentCard":"RecentsModule_recentCard__jryvX"};